import { useEffect, useState } from "react";
import Menu from "./Components/Menu";
import Navbar from "./Components/Navbar";
import Theme from "./Components/Theme";
import AllRoutes from "./Pages/AllRoutes";

const App = () => {
  const [theme, setTheme] = useState('dark-theme');
  const [checked, setChecked] = useState(true);
  const [navToggle, setNavToggle] = useState(false);

  useEffect(() => {
    document.documentElement.className = theme;
  }, [theme]);
  const themeToggler = () => {
    if (theme === 'light-theme') {
      setTheme('dark-theme');
      setChecked(true)
    }
    else {
      setTheme('light-theme')
      setChecked(false)
    }
  }

  return (
    <div className="App">
      <Theme checked={checked} themeToggler={themeToggler} />
      <Menu navToggle={navToggle} setNavToggle={setNavToggle} />
      <Navbar navToggle={navToggle} setNavToggle={setNavToggle} />
      <AllRoutes />
    </div >
  );
}
export default App